import { gql } from '@apollo/client/core'

export const designChallengeFragment = gql`
  fragment DesignChallengeProps on DesignChallenge {
    id
    bannerDesktopImageUrl
    bannerMobileImageUrl
    bannerPrompt
    prompt
    votingUrl
    termsAndConditions
    startAt
    endAt
    status
    vendor {
      id
      name
      isVerified
      logoUrl
    }
    mockup {
      id
    }
  }
`

export const designChallengeSubmissionFragment = gql`
  fragment DesignChallengeSubmissionProps on DesignChallengeSubmission {
    id
  }
`
